var __WEBPACK_NAMESPACE_OBJECT__ = { LambdaMetrics: undefined };